export default "__VITE_ASSET__ab015488__"